import shared from "./shared";
import login from "./login";
import onboarding from "./onboarding";
import company from "./company";
import contact from "./contact";
import registrationFlow from "./registrationFlow";
import changePassword from "./changePassword";
import forgetPassword from "./forgetPassword";
import resetPassword from "./resetPassword";
import admins from "./admins";
import inputsValidations from "./inputsValidations";
import pagesTitles from "./pagesTitles";
import successMsgs from "./successMsgs";
import employees from "./employees";
import events from "./events";
import requests from "./requests";
import applicants from "./applicants";
import timeSheet from "./timeSheet";
import promotionRequests from "./promotionRequests";
import demoRequests from "./demoRequests";
import registrationReq from "./registrationReq";
import publishingRequests from "./publishingRequests";
import companiesList from "./companiesList";
import profileEditRequests from "./profileEditRequests";
import zoneApplicants from "./zoneApplicants";
import evaluations from "./evaluations";
import notifications from "./notifications";
import payroll from "./payroll";
import reason from "./reason";
import report from "./report";
import clientReports from "./clientReports";
import roles from "./roles";
import clients from "./clients";
import clientCompanySelection from "./clientCompanySelection";
import clientSatisfaction from "./clientSatisfactionScore";
import teamManagement from "./teamManagement";
import dashboard from "./dashboard";
import activityLog from "./activityLog";
import { surveyForm } from "./surveyform";

const en = {
  shared,
  login,
  onboarding,
  company,
  contact,
  registrationFlow,
  changePassword,
  forgetPassword,
  resetPassword,
  admins,
  inputsValidations,
  pagesTitles,
  successMsgs,
  employees,
  clients,
  clientCompanySelection,
  events,
  applicants,
  zoneApplicants,
  requests,
  timeSheet,
  promotionRequests,
  demoRequests,
  registrationReq,
  publishingRequests,
  companiesList,
  profileEditRequests,
  evaluations,
  notifications,
  payroll,
  reason,
  report,
  clientReports,
  roles,
  clientSatisfaction,
  teamManagement,
  dashboard,
  activityLog,
  surveyForm
};

export default en;
